<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M10.0846 0.951422C10.5902 0.44588 11.4098 0.44588 11.9154 0.951422L16.5181 5.55416C17.0236 6.0597 17.0236 6.87934 16.5181 7.38489C16.0126 7.89043 15.1929 7.89043 14.6874 7.38489L12.2945 4.99203V15.675C12.2945 16.3899 11.7149 16.9695 11 16.9695C10.2851 16.9695 9.70548 16.3899 9.70548 15.675V4.99203L7.31262 7.38489C6.80708 7.89043 5.98744 7.89043 5.4819 7.38489C4.97635 6.87934 4.97635 6.0597 5.4819 5.55416L10.0846 0.951422ZM1.79452 15.5312C2.50946 15.5312 3.08904 16.1107 3.08904 16.8257C3.08904 17.3979 3.31635 17.9467 3.72097 18.3513C4.12558 18.7559 4.67436 18.9832 5.24658 18.9832H16.7534C17.3256 18.9832 17.8744 18.7559 18.279 18.3513C18.6836 17.9467 18.911 17.3979 18.911 16.8257C18.911 16.1107 19.4905 15.5312 20.2055 15.5312C20.9204 15.5312 21.5 16.1107 21.5 16.8257C21.5 18.0845 20.9999 19.2919 20.1098 20.182C19.2196 21.0722 18.0123 21.5723 16.7534 21.5723H5.24658C3.98771 21.5723 2.7804 21.0722 1.89024 20.182C1.00008 19.2919 0.5 18.0846 0.5 16.8257C0.5 16.1107 1.07958 15.5312 1.79452 15.5312Z" 
        fill="white"
        />
    </svg>
  </span>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'UploadIcon',
  props: {
    width: {
      type: String,
      default: '6px'
    },
    height: {
      type: String,
      default: '10px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
